import axiosInstance from "../api/axiosInstance";

// A staff member discovered in the group's EHR during onboarding who is not yet
// a Nudge user. Surfaced on the members page so an admin can invite them.
export interface EhrDirectoryRow {
  id: number;
  name: string;
  role: string;
  ehr_provider: string;
  npi: string;
  email: string;
  email_masked: string;
  invited: boolean;
  invited_at: string | null;
}

export interface EhrDirectoryResponse {
  count: number;
  // Only group admins may invite (backend-enforced). Used to hide the Invite action.
  can_invite: boolean;
  rows: EhrDirectoryRow[];
}

export interface InviteEhrDirectoryResponse {
  detail: string;
  invited_at: string;
}

export const ehrDirectoryService = {
  getEhrDirectory: async (): Promise<EhrDirectoryResponse> => {
    const response = await axiosInstance.get<EhrDirectoryResponse>("/users/group/ehr-directory/");
    return response.data;
  },

  inviteEhrDirectoryRow: async (
    directoryId: number,
    email: string,
  ): Promise<InviteEhrDirectoryResponse> => {
    const response = await axiosInstance.post<InviteEhrDirectoryResponse>(
      "/users/group/ehr-directory/invite/",
      { directory_id: directoryId, email },
    );
    return response.data;
  },
};
